module.exports = __webpack_public_path__ + "img/game-board-simple.b9eb0d15.svg";